import { Assistance, Gender, IPerson, Person } from "redmond";

export const personToIPerson = (person: Person): IPerson => ({
  ...person,
  gender: Gender[person.gender],
  assistance: person.assistance.map((assistance) => Assistance[assistance]),
});
